import React from 'react';
import {Footer} from 'rsuite'
import {WrapperFooter} from "./index.styled";

function MainFooter() {

    return (
        <WrapperFooter>
            <Footer>
                © Created by <strong>Alex Guerrero</strong> - Happy Hacking
            </Footer>
        </WrapperFooter>);

}

export default MainFooter;
